import TagListing from './TagListing.vue';

export default TagListing;
